import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import classnames from 'classnames'

import actionProptypes from '../../actions/proptypes'
import { createSectionArray } from '../../lib/parse'
import { getCyuQuestionsBySectionId, getCyuProgressDots } from '../../lib/checkUnderstanding'

import { Modal } from 'react-bootstrap'
import { Row } from 'react-bootstrap'
import { Col } from 'react-bootstrap'

import MultipleChoice from '../MultipleChoice'
import AutoFocus from '../AutoFocus'

import base from 'Styles/base.css'
import style from './style.css'
import panelStyle from 'Styles/panel.css'
import colors from 'Styles/baseColors.css'

import closeIcon from 'Assets/x-icon-gray.svg'

export default class CheckYourUnderstandingModal extends Component {
  constructor (props) {
    super(props)

    this.onAnswer = this.onAnswer.bind(this)
    this.updateQuestion = this.updateQuestion.bind(this)

    this.state = {
      isAnswerSelected: false,
      answerSelected: null
    }
  }

  // before we mount, fetch a new L2 MC question and update curCard
  componentWillMount () {
    this.updateQuestion()
  }

  componentDidMount () {
    if (global && global.MathJax) {
      return global.MathJax.Hub.Queue(['Typeset', global.MathJax.Hub])
    }
  }

  componentDidUpdate () {
    if (global && global.MathJax) {
      return global.MathJax.Hub.Queue(['Typeset', global.MathJax.Hub])
    }
  }

  updateQuestion () {
    const cyuQuestions = getCyuQuestionsBySectionId(this.props.activity, this.props.selectedSection.sectionIdInt)

    _.each(cyuQuestions, (question) => {
      this.props.fetchQuestion(question)
    })
  }

  onAnswer (answerValue) {
    if (_.isEmpty(answerValue)) {
      this.setState({
        isAnswerSelected: false
      })
    } else {
      this.setState({
        isAnswerSelected: true,
        answerSelected: answerValue
      })
    }
  }

  onSubmitAnswer (answerSelected) {
    const fqUid = this.props.activity.score.curCard.meta.fq_uid
    this.props.actions.checkAnswer(
      {
        answerSelected,
        fqUid,
        questionType: this.props.activity.score.curCard.questionType,
        selectedSection: this.props.selectedSection,
        cyuIndex: this.props.activity.score.curCard.cyuIndex
      }
    )
    this.setState({
      isAnswerSelected: false
    })
  }

  curCardToMultipleChoiceConfig (item) {
    return {
      question: {
        prompt: item.questionText,
        isComplete: item.completed,
        choices: item.choices.map((choice, index) => ({
          value: index,
          label: choice,
          isAnswered: item.answered.includes(index),
          isCorrect: item.correctAnswerIndex === index,
          isRemoved: item.hinted.includes(index)
        }))
      }
    }
  }

  renderQuestion () {
    const { curCard } = this.props.activity.score
    if (!curCard) return null
    const moduleConfig = this.curCardToMultipleChoiceConfig(curCard)
    return (
      <div>
        <MultipleChoice
          question={moduleConfig.question}
          onAnswer={this.onAnswer}
        />
      </div>
    )
  }

  renderCorrectFooter () {
    const { cyuSectionsRemaining } = createSectionArray(this.props.activity)
    const cyuQuestionsRemaining = getCyuQuestionsBySectionId(this.props.activity, this.props.selectedSection.sectionIdInt)

    const buttonTxt = cyuQuestionsRemaining
      ? 'Next Question'
      : cyuSectionsRemaining > 0 ? 'Next Section' : 'Close Window'

    const clickFunc = cyuQuestionsRemaining ? this.updateQuestion : this.props.onNext

    return (
      <button
        data-test-id="nextCYUQuestion"
        className={classnames('btn-cdl-main', base.pullRight)}
        tabIndex="0"
        onClick={clickFunc}
      >
        <span>{buttonTxt}</span>
      </button>
    )
  }

  renderIncorrectFooter () {
    const { curCard } = this.props.activity.score
    // Display these buttons if submitted incorrect answer
    if (curCard.answeredWrong > 0) {
      return (
        <div className={base.pullRight}>
          <button
            data-test-id="tryAgainBtn"
            className={classnames('btn-cdl-main', style.tryQuizAgainButton)}
            tabIndex="0"
            onClick={() => this.updateQuestion()}
          >
            <span className={style.tryQuizAgainButtonText}>Try Again</span>
          </button>
          <button
            className={classnames('btn-cdl-main')}
            tabIndex="0"
            onClick={this.props.onCancel}
            data-test-id="cyuBackToReadingBtn"
          >
            <span>Back to Reading</span>
          </button>
        </div>
      )
    } else if (this.state.isAnswerSelected) {
      // display this button if answer has been selected but not submitted yet
      return (
        <button
          data-test-id="submitCyuAnswerBtn"
          className={classnames('btn-cdl-main', base.pullRight)}
          tabIndex="0"
          onClick={() => this.onSubmitAnswer(this.state.answerSelected)}
        >
          <span>Submit Answer</span>
        </button>
      )
    }
  }

  renderFeedback () {
    const { curCard } = this.props.activity.score
    if (curCard.answeredWrong > 0 && this.state.answerSelected !== null) {
      const userAnswer = this.props.activity.score.curCard.choices[this.state.answerSelected]
      return (
        <Row>
          <Col xs={12}>
            <AutoFocus tabIndex="0">
              <div className={classnames(panelStyle.base, style.incorrectFeedback)}>
                <p
                  style={{ fontSize: 14, color: colors.colorGrayDarker }}
                >
                  Nope! The correct answer is not:
                </p>
                <p
                  style={{ paddingBottom: 25 }}
                  className={style.jumboText}
                  dangerouslySetInnerHTML={{ __html: userAnswer }}
                />
              </div>
            </AutoFocus>
          </Col>
        </Row>
      )
    } else if (curCard.completed && this.state.answerSelected !== null) {
      const userAnswer = this.props.activity.score.curCard.choices[this.state.answerSelected]
      return (
        <Row>
          <Col xs={12}>
            <AutoFocus tabIndex="0">
              <div className={classnames(panelStyle.base, style.correctFeedback)}>
                <p
                  style={{ fontSize: 14, color: colors.colorGrayDarker }}
                >
                  Yes! The correct answer is:
                </p>
                <p
                  style={{ paddingBottom: 25 }}
                  className={style.jumboText}
                  dangerouslySetInnerHTML={{ __html: userAnswer }}
                />
              </div>
            </AutoFocus>
          </Col>
        </Row>
      )
    }
    return null
  }

  render () {
    const { curCard } = this.props.activity.score
    if (!curCard) return null
    return (
      <div>
        <Modal show={true} className={classnames(style.modalContainer)}>
          <Modal.Body className={style.container} data-test-id="cyuModal">
            <div>
              <Row>
                <Col xs={10}>
                  <h2 className={style.tipsModalHeader}>
                    Check Your Understanding
                  </h2>
                  <div className={style.progressDots}>
                    {getCyuProgressDots(this.props.activity, this.props.selectedSection)}
                  </div>
                </Col>
                <Col xs={2}>
                  <button
                    data-test-id="hideCheckBtn"
                    aria-label="Close Check Your Understanding Quiz"
                    className={classnames(style.hideTips)}
                    onClick={this.props.onCancel}
                    tabIndex="0"
                  >
                    <object
                      data={closeIcon} type="image/svg+xml"
                      className={base.svgIcon}
                      tabIndex="-1"
                    />
                  </button>
                </Col>
              </Row>
              <div className={style.MathJaxWrapper}>
                {this.renderFeedback()}
                {this.renderQuestion()}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className={classnames('modal-footer', style.footerContainer)}>
            {curCard.completed
              ? this.renderCorrectFooter()
              : this.renderIncorrectFooter()
            }
          </Modal.Footer>
        </Modal>
      </div>
    )
  }
}

CheckYourUnderstandingModal.propTypes = {
  actions: actionProptypes,
  activity: PropTypes.object.isRequired,
  onCancel: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  fetchQuestion: PropTypes.func.isRequired,
  selectedSection: PropTypes.object.isRequired
}
